import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import { useAuth } from '../../../contexts/AuthContext';
import { useJarvisChat } from './useJarvisChat';
import { ChatPanel } from './ChatPanel';
import { ActionSheet } from '../ActionSheet';

const Floating = ({ onClose }) => {
  const { token } = useAuth();
  const chat = useJarvisChat();
  const [sel, setSel] = useState(null);
  return (
    <>
      <ChatPanel chat={chat} onAction={(a) => setSel(a.insight)} onClose={onClose}
        className={`jv-vars fixed inset-x-0 bottom-0 ${sel ? 'z-40' : 'z-[95]'} h-[85vh] rounded-b-none sm:inset-x-auto sm:bottom-24 sm:right-6 sm:h-[600px] sm:max-h-[78vh] sm:w-[420px] sm:rounded-b-[24px]`} />
      <ActionSheet token={token} insight={sel} open={!!sel} onClose={() => setSel(null)} onChanged={() => window.dispatchEvent(new Event('jarvis:changed'))} />
    </>
  );
};

// Jarvis button on every page (small and still on phones; hidden there on /calling). Hidden on /jarvis (chat is embedded there). Opens via `jarvis:chat-open` too.
export const ChatLauncher = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { const on = () => setOpen(true); window.addEventListener('jarvis:chat-open', on); return () => window.removeEventListener('jarvis:chat-open', on); }, []);
  if (pathname.startsWith('/jarvis')) return null;
  const hideOnPhone = pathname.startsWith('/calling');
  return (
    <>
      {open && <Floating onClose={() => setOpen(false)} />}
      {!open && (
        <button type="button" onClick={() => setOpen(true)} aria-label="Chat with Jarvis" data-testid="jarvis-chat-launcher-button"
          className={`group fixed bottom-24 right-3 z-[85] ${hideOnPhone ? 'hidden md:grid' : 'grid'} h-10 w-10 md:h-14 md:w-14 place-items-center rounded-full border border-white/30 md:border-2 bg-gradient-to-tr from-[#0E1B4D] to-[#2347FF] shadow-lg md:shadow-2xl opacity-90 md:opacity-100 transition-transform hover:scale-105 active:scale-95 md:right-6`} style={{ color: '#fff' }}>
          <span className="absolute inset-0 hidden rounded-full bg-[#3CC8FF]/20 motion-safe:animate-ping md:block" style={{ animationDuration: '3s' }} />
          <MessageCircle className="relative h-5 w-5 md:h-6 md:w-6" />
          <span className="pointer-events-none absolute right-16 whitespace-nowrap rounded-lg bg-[#0E1B4D] px-2.5 py-1 text-xs font-semibold opacity-0 transition-opacity group-hover:opacity-100" style={{ color: '#fff' }}>Ask Jarvis</span>
        </button>
      )}
    </>
  );
};

export default ChatLauncher;
